import React, { useState } from 'react';
import { PageHeader } from '../../components/UI';
import KontrakDashboardTab from './tabs/KontrakDashboardTab';
import KontrakListTab from './tabs/KontrakListTab';
import KontrakFormTab from './tabs/KontrakFormTab';
import KontrakDetailTab from './tabs/KontrakDetailTab';

const KontrakPage = () => {
  const [tab, setTab] = useState('dashboard');
  const [editId, setEditId] = useState(null);
  const [tipeFilter, setTipeFilter] = useState('');

  const tabs = [
    { id: 'dashboard', label: 'Dashboard' },
    { id: 'list', label: 'Semua' },
    { id: 'kontrak', label: 'Kontrak' },
    { id: 'spk', label: 'SPK' },
    { id: 'create', label: 'Buat Baru' },
  ];

  const handleEdit = (id) => { setEditId(id); setTab('detail'); };
  const handleEditKontrak = (id) => { setEditId(id); setTab('create'); };
  const handleNew = () => { setEditId(null); setTab('create'); };

  return (
    <div>
      <PageHeader title="PPK — Komitmen" subtitle="Kontrak vendor, SPK, addendum, dan milestone pembayaran" />
      <div style={{ display: 'flex', gap: 8, marginBottom: 24, borderBottom: '1px solid #E5E7EB', overflowX: 'auto' }}>
        {tabs.map(t => (
          <button key={t.id} onClick={() => setTab(t.id)}
            style={{ padding: '12px 16px', borderBottom: tab === t.id ? '2px solid #7C3AED' : 'none', color: tab === t.id ? '#7C3AED' : '#6B7280', fontWeight: tab === t.id ? 600 : 500, border: 'none', background: 'none', cursor: 'pointer', whiteSpace: 'nowrap' }}>
            {t.label}
          </button>
        ))}
        {tab === 'detail' && (
          <button onClick={() => setTab('detail')} style={{ padding: '12px 16px', borderBottom: '2px solid #7C3AED', color: '#7C3AED', fontWeight: 600, border: 'none', background: 'none', cursor: 'pointer', whiteSpace: 'nowrap' }}>
            Detail Kontrak
          </button>
        )}
        {tab === 'create' && editId && (
          <button onClick={() => setTab('create')} style={{ padding: '12px 16px', borderBottom: '2px solid #7C3AED', color: '#7C3AED', fontWeight: 600, border: 'none', background: 'none', cursor: 'pointer', whiteSpace: 'nowrap' }}>
            Edit Kontrak
          </button>
        )}
      </div>

      {tab === 'dashboard' && <KontrakDashboardTab />}
      {tab === 'list' && <KontrakListTab onEdit={handleEdit} onNew={handleNew} />}
      {tab === 'kontrak' && <KontrakListTab onEdit={handleEdit} onNew={handleNew} tipeFilter="KONTRAK" />}
      {tab === 'spk' && <KontrakListTab onEdit={handleEdit} onNew={handleNew} tipeFilter="SPK" />}
      {tab === 'create' && <KontrakFormTab editId={editId} onSuccess={() => { setTab('list'); setEditId(null); }} />}
      {tab === 'detail' && <KontrakDetailTab id={editId} onBack={() => { setTab('list'); setEditId(null); }} onEditKontrak={handleEditKontrak} />}
    </div>
  );
};

export default KontrakPage;
